import type { ProductDetailsData } from "@jti/fe-common";
import type { ConsumablesMatrixData } from "@jti/product-details";

import type { ProductTeaserCarouselProps } from "@/components/ProductTeaserCarousel/ProductTeaserCarousel.inputs";

import { createSafeContentWithData } from "../builder/tools/createSafeContentWithData/createSafeContentWithData";

import type { ProductsMap } from "./products";

const { Content: ConsumablesProductContent, createDefaultDataBindings: createConsumablesProductDefaultDataBinding } =
  createSafeContentWithData<{
    productSku: string;
    productBadgeText: string;
    productOverwriteBadgeText: string;
    productDescription: string;
    productShortDescription: string;
    productKnowMoreUrl: string;
    productMultiPackDescription: string;
    productName: string;
    productIsCommerceDisabled: boolean;
    productIsMultiPackEnabled: boolean;
    productMultiPackName: string;
    productMultiPackProducts: ProductDetailsData["multiPackProducts"];
    productCustomBuyCtaLabel: string;
    productConsumablesMatrixData: ConsumablesMatrixData;
    productIsSubscriptionsEnabled: boolean;
    teaserProducts: ProductTeaserCarouselProps["items"];
    products: ProductsMap;
  }>();

export { ConsumablesProductContent, createConsumablesProductDefaultDataBinding };
